<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import RoundCheckIcon from 'desktop/icons/RoundCheckLarge.svelte';

    import s from './style.module.css';
</script>

<OpacityItem delayIn={0}>
    <div class={s.main} style="margin-top: {$dyData.side.typ?.marginTop || 0}">
        <div style="width: 100%">
            <div class={s.checkIcon}>
                <RoundCheckIcon size={68} color="#00995C" />
            </div>
            <Description
                value={$dyData.description?.typ}
                template={TEMPLATE.SQUARE_EXIT_REDESIGN}
            />
            <div class={s.buttonContainer}>
                <DyButton
                    type="quiz"
                    href="/pairfect_match"
                    children="Take the Quiz"
                    onClick={modal.close}
                    size="medium"
                    color="blue"
                />
            </div>
            <ActionButton
                color="nevadaCold"
                marginTop="14px"
                children="Continue Shopping"
                fontSize="16px"
                handleClick={modal.close}
            />
        </div>
    </div>
</OpacityItem>
